<template>
  <v-container fluid>
    <v-dialog v-model="isLoading" fullscreen>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Manage MH1 with {{pmsConnDetails.usr}}
            <v-spacer></v-spacer>
            <v-scale-transition>
              <v-chip right class="ma-2" color="orange" text-color="white" v-show="isDirty">
                Changes Pending
              </v-chip>
            </v-scale-transition>
          </v-card-title>
          <v-card-subtitle>
            {{pmsConnDetails.pmsType}} | PMS Information retrieved:
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <timeago :datetime="pmsInfo.ctdTs" :auto-update="60"></timeago>
                </span>
              </template>
              <span>{{new Date(pmsInfo.ctdTs)}}</span>
            </v-tooltip>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <v-stepper :value="activeStep" :vertical="true" non-linear>
      <template v-for="(step,index) in steps">
        <v-stepper-step
          :name="step.name"
          :step="index+1"
          :key="index+'_Header'"
          :editable="true"
          :complete="true"
          edit-icon="$complete"
        >
          {{step.title}}
          <small>{{step.subtitle}}</small>
        </v-stepper-step>
        <v-stepper-content :step="index+1" :key="index+'_Content'">
          <component
            :is="step.content"
            :pmsInfo="pmsInfo"
            :index="index+1"
            @change-step="activeStep = index"
            v-on:step-is-valid="step.isValid=$event"
            v-model="addMh1Context"
          ></component>
          <v-btn right @click="nextStep(step, index)" color="primary" :disabled="false">Continue</v-btn>
          <v-btn v-if="activeStep > 1" @click="activeStep--" color="normal">Back</v-btn>
        </v-stepper-content>
      </template>
      <v-stepper-step
        name="Finalise"
        :step="steps.length+1"
        :key="(steps.length+1)+'_Header'"
        :editable="true"
        :complete="true"
        edit-icon="$complete"
      >Finalise</v-stepper-step>
      <v-stepper-content :step="steps.length+1">
        <v-btn
          right
          :disabled="!isDirty"
          color="primary"
          @click="publishChanges()"
          :loading="publishChangesBusy"
        >Publish Changes</v-btn>

        <v-alert v-if="finished" type="info">
          Your changes have been applied. You may want to go:
          <v-btn
            :to="{ name: 'PmsConnProducts', params: { sub: $route.params.sub}}"
          >Back to Products</v-btn>
        </v-alert>
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";
import * as mutations from "@/graphql/mutations";

import SelectSite from "./mh1/SelectSite";
import ChooseNewOrExisting from "./mh1/ChooseNewOrExisting";
import PracticeDetails from "./mh1/PracticeDetails";
import ManageTreatments from "./mh1/ManageTreatments";
import SelectBooks from "./mh1/SelectBooks";
import ManageBooks from "./mh1/ManageBooks";
import SelectFeatures from "./mh1/SelectFeatures";
import Maintenance from "./mh1/Maintenance";
import ConfirmUpdateDialog from "./mh1/ConfirmUpdateDialog";

export default {
  props: {
    pmsConnDetails: Object,
    pmsInfo: Object,
    pmsInfoLoading: Boolean,
  },
  created: async function () {
    this.isLoading = true;
    try {
      window.addEventListener("beforeunload", this.beforeWindowUnload);
      const sub = this.$route.params.sub;
      const acc = this.$route.params.mh1PracticeId;

      console.log("created", sub);
      await this.getLinks(sub);

      // do setup in loading watch handler
    } finally {
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeWindowUnload);
  },
  watch: {
    addMh1Context: {
      handler(newVal, oldVal) {
        console.log("watch addMh1Context handler", newVal, oldVal);
        if (this.dirtyStateReset) {
          console.log(
            "watch addMh1Context handler ignoring change, stateReset true"
          );
          this.dirtyStateReset = false;
          return;
        }

        this.isDirty = true;
        console.log("watch addMh1Context handler set dirty");
      },
      deep: true,
    },
    pmsInfo: {
      handler(newVal, oldVal) {
        console.log("ManageMh1 watch pmsinfo", newVal, oldVal);
      },
    },
    pmsInfoLoading: {
      handler(val, oldVal) {
        console.log(
          "ManageMh1 watch pmsInfoLoading",
          val,
          oldVal,
          this.getLinksLoading,
          this.pmsInfoLoading
        );
        this.isLoading = this.getLinksLoading || this.pmsInfoLoading;
      },
    },
    getLinksLoading: {
      handler(val, oldVal) {
        console.log(
          "ManageMh1 watch getLinksLoading",
          val,
          oldVal,
          this.getLinksLoading,
          this.pmsInfoLoading
        );
        this.isLoading = this.getLinksLoading || this.pmsInfoLoading;
      },
    },
    isLoading: {
      handler(val, oldVal) {
        console.log("ManageMh1 watch isLoading ", val, oldVal);
        if (!val && oldVal) {
          console.log(
            "ManageMh1 isLoading finished, populating",
            this.getLinksLoading,
            this.pmsInfoLoading,
            this.pmsInfo
          );

          const sub = this.$route.params.sub;
          const acc = this.$route.params.mh1PracticeId;
          this.populateContextFromLinks(acc);

          console.info("ManageMh1 watch seting isdirty to false");
          this.dirtyStateReset = true;
          this.isDirty = false;
        }
      },
    },
  },
  async beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave");
    if (!this.isDirty) {
      next();
    } else {
      const res = await this.$dialog.warning({
        text:
          "Your pending changes have not been saved. Are you sure you want to leave?",
        title: "Warning",
        icon: "mdi-alert",
      });

      if (res) {
        next();
      } else {
        next(false);
      }
    }
  },
  computed: {
    selectedSite: function () {
      console.log(
        "selectedsite",
        this.addMh1Context.selectedSiteId,
        this.pmsInfo?.sites
      );
      return (
        this.pmsInfo?.sites?.find(
          (s) => s.pmsSiteId == this.addMh1Context.selectedSiteId
        ) ?? {}
      );
    },
    steps: function () {
      const selectSiteTitle =
        this.pmsInfo?.sites?.length > 1
          ? "Select PMS Site"
          : "Review PMS Site Information";
      return [
        /*
        {
          name:"selectPMSSite",
          title: selectSiteTitle,
          subtitle: "",
          content: SelectSite
        },
        {
          name:"newOrExistingMh1Practice",
          title: "New or Existing MyHealth1st Practice",
          subtitle: "",
          content: ChooseNewOrExisting,
        },
        {
          name:"practiceDetails",
          title: "MyHealth1st Practice Details",
          subtitle: "",
          content: PracticeDetails,
        },*/
        {
          title: "Sync Settings",
          subtitle: "",
          content: SelectFeatures,
        },
        {
          title: "Select Books to Synchronize",
          subtitle: "",
          content: SelectBooks,
        } /*
        {
          title: "Manage Treatments",
          subtitle: "",
          content: ManageTreatments,
        },*/,
        {
          title: "Setup Synchronized Books",
          subtitle: "",
          content: ManageBooks,
        } /*,
        {
          title: "Automatic Maintenance",
          subtitle: "",
          content: Maintenance,
        },*/,
      ];
    },
  },
  data: function () {
    return {
      addMh1Context: {
        mode: "manage",
        products: [],
        selectedSiteId: "",
        newOrExisting: "existing",
        links: {},
        username: "",
        encryptedPassword: "",
        timeZone: "",
        notificationChannel: "",
        pmsBooksToSync: [],
        features: {
          mh1EasyRecalls: {
            pmsSiteId: "",
          },
        },
      },
      activeTab: 0,
      activeStep: 1,
      isDirty: false,
      dirtyStateReset: false,
      isLoading: false,
      getLinksLoading: false,
      finished: false,
      publishChangesBusy: false,
      mh1BaseUri: process.env.VUE_APP_MH1_BASE_URI,
    };
  },
  methods: {
    beforeWindowUnload(e) {
      if (this.isDirty) {
        e.preventDefault();
        e.returnValue = "";
      }
    },
    populateContextFromLinks: function (mh1PracticeId) {
      const ctx = this.addMh1Context;

      ctx.selectedMh1Practice = mh1PracticeId;
      ctx.newOrExisting = "existing";

      const links = this.addMh1Context?.links;

      if (!ctx || !links) {
        console.log("cannot populate context from links", links, ctx);
        return;
      }

      const acc = links.accounts?.find(
        (thatAcc) =>
          thatAcc.platform == "mh1" && thatAcc.accountId == mh1PracticeId
      );

      if (!acc) {
        console.log("cannot find mh1 acc for ", mh1PracticeId, links);
      }

      ctx.selectedSiteId = acc.primaryPmsSiteId;
      ctx.newOrExisting = "existing";
      ctx.existingMh1PracticeId = acc.accountId;

      //ctx.selectedSiteId = links.primaryPmsSiteId;
      ctx.products = acc.products;

      ctx.username = acc.username;
      ctx.encryptedPassword = acc.encryptedPassword;
      ctx.timeZone = acc.timeZone;
      ctx.notificationChannel = acc.notificationChannel;

      if (acc.mh1EasyRecalls?.pmsSiteId) {
        ctx.features.mh1EasyRecalls.pmsSiteId = acc.mh1EasyRecalls.pmsSiteId;
      }

      for (const book of acc.olbBooks ?? []) {
        const pmsBooksForSite = this.getAllSiteBooks();

        console.log("got pmsbooksforsite", pmsBooksForSite);

        const pmsBook = pmsBooksForSite?.find(
          (b) => b.book.pmsBookFQId == book.pmsBookFQId
        );
        if (!pmsBook) {
          console.log("canot find pms info book in selected site", book);
          continue;
        }

        pmsBook.selectedMh1BookId = book.olbBookId;
        pmsBook.newOrExisting = "existing";

        pmsBook.mappings = [];
        console.log("iterate mappings ", book.treatmentMappings);
        for (const tm of book.treatmentMappings ?? []) {
          pmsBook.mappings.push({
            mh1TreatmentId: tm.olbTreatmentId,
            pmsAppointmentTypeId: tm.pmsAppointmentTypeId,
          });
        }
        console.log(
          "got treatment mappings for book",
          book.treatmentMappings,
          pmsBook.mappings
        );
          pmsBook.appointmentTypes = [];
        console.log("iterate appointmentTypes ", book.appointmentTypes);
        for (const tm of book.appointmentTypes ?? []) {
          pmsBook.appointmentTypes.push({
            name: tm.name,
          });
        }

        console.log(
          "got appointmentTypes for book",
          book.appointmentTypes,
          pmsBook.appointmentTypes
        );

        ctx.pmsBooksToSync.push(pmsBook);
      }
      console.log("set pmsBooksToSync", ctx.pmsBooksToSync, acc.olbBooks);
    },
    nextStep: function (step, index) {
      step.editable = true;
      step.complete = true;
      this.activeStep = index + 2;
    },
    tabClick: function () {
      return false;
    },
    async getLinks(sub) {
      this.getLinksLoading = true;
      try {
        // Simple query
        //const allStatus = await API.graphql(graphqlOperation(queries.listStatus));
        console.log("getLinks called", sub);
        const status = await API.graphql(
          graphqlOperation(queries.getLinks, { sub: sub })
        );

        console.log("getLinks returned", status);

        if (!status.data?.getLinks?.sub) {
          console.log("getlinks did not get valid links", status);
        }

        const result = status.data?.getLinks || {
          sub: sub,
          accCount: 0,
          ctd: new Date().toString(),
          ctdTs: +new Date(),
          accounts: [],
        };

        this.addMh1Context.links = result;

        // copy obj for ref
        this.linksUnchanged = JSON.parse(JSON.stringify(result));

        this.linksStateReset = true;
        this.linksDirty = false;
      } catch (err) {
        console.log("getLinks err", err);
      } finally {
        this.getLinksLoading = false;
      }
    },
    getAllSiteBooks: function () {
      let bookInfoAllSites = [];
      if ((this.pmsInfo?.sites?.length ?? 0) == 0) {
        console.log(
          "getAllSiteBooks pmsInfo.sites not available",
          this.pmsInfo
        );
        return;
      }
      for (const site of this.pmsInfo?.sites ?? []) {
        if (site.appointmentBooks?.length > 0)
        {
        const bookInfo = site.appointmentBooks?.map((b) => {
          const resourcesForBook =
            b.pmsResourceIds
              ?.map((bookResourceId) =>
                this?.pmsInfo?.resources?.find(
                  (r) => r.pmsResourceId == bookResourceId
                )
              )
              ?.filter((n) => n) ?? [];
          return {
            book: b,  
            resources: resourcesForBook,
          };
        });

        bookInfoAllSites = bookInfoAllSites.concat(bookInfo);
        }
      }

      return bookInfoAllSites;
    },
    async publishChanges() {
      this.publishChangesBusy = true;
      try {
        console.log(
          "publishChanges addMh1Context.links",
          this.addMh1Context.links
        );
        console.log("publishChanges addMh1Context", this.addMh1Context);

        const links = this.addMh1Context.links;

        if (
          this.addMh1Context.newOrExisting == "new" ||
          !this.addMh1Context.existingMh1PracticeId
        ) {
          console.log(
            "publishChanges newAccount",
            this.addMh1Context.newOrExisting,
            this.addMh1Context.existingMh1PracticeId
          );
          this.$dialog.error({
            text: "This screen only allows managing an existing account.",
          });
          return;
        }

        const foundAccountIndex = links.accounts.findIndex(
          (acc) =>
            acc.platform == "mh1" &&
            acc.accountId == this.addMh1Context.existingMh1PracticeId
        );

        if (foundAccountIndex < 0) {
          console.log(
            "publishChanges foundAccount cannot find account",
            foundAccount
          );
          this.$dialog.error({
            text: "Cannot find configured account in links.",
          });
          return;
        }

        const olbBooks = [];

        for (const item of this.addMh1Context.pmsBooksToSync) {
          const treatmentMappings = [];
           const appointmentTypes = [];
    console.log("item ",item );
          for (const itemMapping of item.mappings ?? []) {
            treatmentMappings.push({
              olbTreatmentId: itemMapping.mh1TreatmentId.toString(),
              pmsAppointmentTypeId: itemMapping.pmsAppointmentTypeId,
            });
          }
          console.log("item.appointmentTypes ",item.appointmentTypes );
           for (const type of item.appointmentTypes ?? []) {
            appointmentTypes.push({
               name: type.name,
            });
          }

          const olbBook = {
            olbBookId: item.selectedMh1BookId,
            pmsBookFQId: item.book.pmsBookFQId,
          };

          if (treatmentMappings.length > 0) {
            olbBook["treatmentMappings"] = treatmentMappings;
          }
          if (appointmentTypes.length > 0) {
            olbBook["appointmentTypes"] = appointmentTypes;
          }

          olbBooks.push(olbBook);
        }
        const newAccount = {
          accountId: this.addMh1Context.existingMh1PracticeId,
          baseUrl: this.mh1BaseUri,
          encryptedPassword: this.addMh1Context.encryptedPassword,
          notificationChannel: this.addMh1Context.notificationChannel,
          olbBooks,
          platform: "mh1",
          products: this.addMh1Context.products,
          timeZone: this.addMh1Context.timeZone,
          username: this.addMh1Context.username,
          primaryPmsSiteId: this.addMh1Context.selectedSiteId,
        };

        if (
          this.addMh1Context.products.find(
            (p) => p?.toLowerCase() ?? "" === "mh1easyrecalls"
          )
        ) {
          newAccount.mh1EasyRecalls = {
            pmsSiteId:
              this.addMh1Context.features?.mh1EasyRecalls?.pmsSiteId ?? "",
          };
        }

        const confirmResult = await this.$dialog.showAndWait(
          ConfirmUpdateDialog,
          {
            oldData: links.accounts[foundAccountIndex],
            newData: newAccount,
            width: 1200
          },
        );

        if (confirmResult?.action != "ok") {
          console.info("User cancelled update");
          return;
        }

        links.accounts[foundAccountIndex] = newAccount;

        links.accCount = links.accounts.length;

        try {
          console.log("stubCall updateLinks with", links);

          const updateLinksResult = await API.graphql(
            graphqlOperation(mutations.updateLinks, { input: links })
          );

          console.log("Product added result", updateLinksResult);

          this.addMh1Context.links = updateLinksResult.data.updateLinks;

          this.$dialog.notify.info("Product added");
        } catch (err) {
          console.log("Product added error", err);

          const notifyResult = await this.$dialog.notify.error(
            "Error Adding Product account",
            {
              position: "top-right",
              timeout: 5000,
              actions: [{ text: "Info", "x-small": true, color: "secondary" }],
            }
          );

          if (notifyResult == "Info") {
            this.$dialog.error({
              text: JSON.stringify(err),
              title: "Cannot save links",
              icon: "mdi-error",
            });
          }

          // MH1 Hub Api calls for each sync'd book set pmsPractitionerCode / pmsLocation
          for (const item of this.addMh1Context.pmsBooksToSync) {
            console.log("set mh1 sync values for ", item);
            if (item.newOrExisting == "new" || !item.selectedMh1BookId) {
              console.log(
                "publishChanges newBook",
                item.newOrExisting,
                item.selectedMh1BookId,
                item
              );
              this.$dialog.error({
                text:
                  "Only using an existing MH1 Book is supported at this time.",
              });
              return;
            }

            const parts = item.book.pmsBookFQId.split("::");

            const locationId = parts.length > 1 ? parts[0] : "";

            const practitionerCode =
              parts.length > 1
                ? parts.splice(1).join("::")
                : item.book.pmsBookFQId;

            try {
              // MH1 Hub Api calls for each sync'd book set pmsPractitionerCode / pmsLocation

              console.log(
                "stubCall setMh1PractitionerCode",
                item.selectedMh1BookId,
                practitionerCode,
                locationId,
                parts,
                item
              );

              const setMh1PractitionerCodeResult = await API.graphql(
                graphqlOperation(mutations.setMh1PractitionerCode, {
                  appointmentBookId: item.selectedMh1BookId,
                  practitionerCode,
                  locationId,
                })
              );

              console.log(
                "got setMh1PractitionerCodeResult",
                item.selectedMh1BookId,
                practitionerCode,
                locationId,
                setMh1PractitionerCodeResult
              );
            } catch (err) {
              console.log(
                "publishChanges setMh1PractitionerCode err",
                item.selectedMh1BookId,
                item.book.pmsBookFQId,
                practitionerCode,
                locationId,
                err
              );
              await this.handleResponseError(
                "Error Updating MH1 Appointment Book Pracitioner/Location Codes",
                err
              );
              return;
            }
          }
        }
        this.dirtyStateReset = true;
        this.isDirty = false;
        this.finished = true;
      } finally {
        this.publishChangesBusy = false;
      }
    },
  },
};
</script>